import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import "./customised-tabs.styles.scss";

//icons
// import FlashOnIcon from '@material-ui/icons/FlashOn';
// import TrendingUpIcon from '@material-ui/icons/TrendingUp';
// import LocalAtmIcon from '@material-ui/icons/LocalAtm';
// import SyncAltIcon from '@material-ui/icons/SyncAlt';
// import StopIcon from '@material-ui/icons/Stop';
// import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
// import LayersIcon from '@material-ui/icons/Layers';

import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";

import InputsBlock from "../inputs/inputs.component";
import Equivalents from "../equivalents/equivalents.component";
import Warning from "../warning/warning.component";

import axios from "axios";

// const tab_names = [
//   ['ENERGY RATE', <TrendingUpIcon />],
//   ['ENERGY', <FlashOnIcon />],
//   ['VOLUME', <LayersIcon />],
//   ['MASS', <FitnessCenterIcon />],
//   ['AREA', <StopIcon />],
//   ['ENERGY COST', <LocalAtmIcon />],
//   ['LENGTH', <SyncAltIcon />],
// ];
// let tab_list = [];
// tab_names.forEach((item, index) => {
//   tab_list.push(<Tab label={item[0]} icon={item[1]} {...a11yProps(index)} />);
// });

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    justifyContent: "center",
  },
  scroller: {
    flexGrow: "0",
  },
}));

export default function CustomisedTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [unitTypes, setUnitTypes] = useState([]);
  const [data, setData] = useState([]);
  const [units, setUnits] = useState([]);
  // const [formInputs, setFormInputs] = useState({
  //   inputValue: '',
  //   fromValue: '',
  // });
  const [inputValue, setInputValue] = useState("");
  const [fromValue, setFromValue] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      // const getUnitTypes = await axios
      //   .get('https://olwg-unit-converter.azurewebsites.net/api/get_units')
      //   .catch((err) => {
      //     console.log(err);
      //   });
      const getData = await axios
        .get("https://olwg-api.azurewebsites.net/api/get_all_values")
        .catch((err) => {
          console.log(err);
        });

      // console.log(getUnitTypes.data);
      // console.log(getData.data);
      // setUnitTypes(
      //   Array.from(
      //     getData.data.reduce(
      //       (acc, cur) =>
      //         acc.add(cur.PartitionKey.toUpperCase().replace(/_/g, ' ')),
      //       new Set()
      //     )
      //   )
      // );
      setUnitTypes(
        getData.data
          .map((item) => item.PartitionKey)
          .reduce(
            (unique, item) =>
              unique.includes(item) ? unique : [...unique, item],
            []
          )
      );
      setData(getData.data);
      setUnits(
        getData.data.filter(
          (item, index, array) => item.PartitionKey === array[0].PartitionKey
        )
      );
    };

    fetchData();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const inputChange = (newValue) => {
    setInputValue(newValue);
  };

  const fromChange = (newValue) => {
    setFromValue(newValue);
  };

  const handleClick = (unitType) => {
    // try {
    //   await axios
    //     .get(
    //       `https://olwg-unit-converter.azurewebsites.net/api/get_inputs_data/?unitType=${unitType}`
    //     )
    //     .then((res) => {
    //       console.log(res);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } catch (error) {
    //   console.log(error);
    // }
    setUnits(data.filter((item) => item.PartitionKey === unitType));
  };

  return (
    <ScopedCssBaseline>
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            classes={{ root: classes.root, scroller: classes.scroller }}
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
          >
            {unitTypes.map((unitType, index) => (
              <Tab
                label={unitType.replace(/_/g, " ")}
                icon=""
                onClick={() => handleClick(unitType)}
                key={index}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </AppBar>
        {unitTypes.map((unitType, index) => (
          <TabPanel value={value} index={index} key={index}>
            <InputsBlock
              units={units}
              fromChange={fromChange}
              inputChange={inputChange}
            />
            <Equivalents
              units={units}
              inputValue={inputValue}
              fromValue={fromValue}
            />
            <Warning />
          </TabPanel>
        ))}
      </div>
    </ScopedCssBaseline>
  );
}
